<template>
	<section>
		<div class="contract-form">
			<div class="mb-4">
				<label class="font-normal">{{ $t('Nombre') }}</label>
				<input
					type="text"
					v-model="field.name"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.field.name.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.field.name.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Tabla') }}</label>
				<select
					v-model="field.tableName"
					@change="resetFieldName()"
					class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option>contracts</option>
					<option>users</option>
					<option>conf_contract_types</option>
					<option>conf_contract_retention</option>
					<option>organizations_delegations</option>
					<option>conf_campaigns</option>
				</select>
				<div v-if="$v.field.tableName.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.field.tableName.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Campo') }}</label>
				<select
					v-model="field.fieldName"
					class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option v-for="(field, index) in fields" :key="index">
						{{ field }}
					</option>
				</select>
				<div v-if="$v.field.fieldName.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.field.fieldName.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Variable') }}</label>
				<input
					type="text"
					v-model="field.variable"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.field.variable.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.field.variable.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
		</div>
		<div class="flex justify-end">
			<ButtonBlack class="mt-4 text-right" @click.native="submit">
				<div v-if="loading">
					<pulse-loader
						:loading="loading"
						:color="'#fff'"
						:size="'10px'"
					></pulse-loader>
				</div>
				<div v-else>{{ buton_text }}</div>
			</ButtonBlack>
		</div>
		<div v-if="error" class="mt-1">
			<p class="text-sm text-red-500">{{ $t('error') }}</p>
			<ul class="text-sm error-list" v-html="server_error"></ul>
		</div>
	</section>
</template>

<script>
import { single } from '@/mixins'
import { required, maxLength } from 'vuelidate/lib/validators'
import { queryContractFieldsByPk } from '@/apollo/queries/admin/contract_fields'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { queryTableFields } from '@/apollo/queries/admin/table_fields'
import {
	updateSingleContractField,
	insertSingleContractField
} from '@/apollo/mutations/admin/contract_fields'

export default {
	mixins: [single],
	components: {
		PulseLoader
	},
	apollo: {
		field() {
			const query = queryContractFieldsByPk(this.id)
			query.skip = this.id == null
			return query
		}
	},
	watch: {
		'field.tableName': function (table) {
			this.startLoadingState()
			this.$apollo
				.query(queryTableFields(table))
				.then(data => {
					const filtered = this.filterTableFields(data.data.__type.fields)
					filtered.sort()
					this.fields = ['', ...filtered]
					this.stopLoadingState()
				})
				.catch(() => this.stopLoadingState())
		}
	},
	data() {
		return {
			title: this.$i18n.t('Templates'),
			section: 'variables',
			field: {
				name: null,
				tableName: '',
				fieldName: '',
				variable: null
			},
			fields: []
		}
	},
	methods: {
		resetFieldName() {
			this.field.fieldName = ''
		},
		filterTableFields(fields) {
			return fields
				.filter(
					field =>
						field.type.ofType === null || field.type.ofType.kind === 'SCALAR'
				)
				.map(field => field.name)
		},
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$apollo
					.mutate(
						this.id != null
							? updateSingleContractField(this.id, this.field)
							: insertSingleContractField(this.field)
					)
					.then(() => this.stopLoadingState())
					.catch(error => {
						this.setError(error)
					})
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	},
	validations() {
		let validations = {
			field: {
				name: {
					required,
					maxLength: maxLength(50)
				},
				tableName: {
					required
				},
				fieldName: {
					required
				},
				variable: {
					required
				}
			}
		}
		return validations
	},
	props: {
		id: String
	}
}
</script>
